import type { Route } from '@angular/router';
import {
  sequentialDeactivateGuards,
  hasStringPathParamCanActivateGuard,
} from '@pct-ng/core/router';
import { showToasterDeactivateGuard } from '@pct-ng/form';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';

export const newsCategoryRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/news-category-list.component').then(
        ({ NewsCategoryListComponent }) => NewsCategoryListComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/news-category-details.component').then(
        ({ NewsCategoryDetailsComponent }) => NewsCategoryDetailsComponent,
      ),
    title: 'PAGES.NEWS.CATEGORY.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.NEWS.CATEGORY.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/news-category-details.component').then(
        ({ NewsCategoryDetailsComponent }) => NewsCategoryDetailsComponent,
      ),
    title: 'PAGES.NEWS.CATEGORY.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.NEWS.CATEGORY.SINGULAR'),
      ]),
    ],
  },
];
